import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { DownloadJobService } from '../../shared/services/download-job.service';
import { HistoryRow, ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';

@Component({
    selector: 'xp-completed-requests',
    templateUrl: './completed-requests.component.html',
    styleUrl: './completed-requests.component.scss'
})
export class CompletedRequestsComponent implements OnInit {
    @ViewChild(RouterOutlet) outlet!: RouterOutlet;
    isToggleOn = false;
    selectedTabIndex: number = 0;

    constructor(private router: Router, private route: ActivatedRoute, private downloadJobService: DownloadJobService) {

    }

    ngOnInit() {
        const path = this.route.snapshot.firstChild?.routeConfig?.path;
        switch (path) {
            case 'payment-completed-requests': this.selectedTabIndex = 0; break;
            case 'expect-fund-completed': this.selectedTabIndex = 1; break;
            case 'transfer-completed-requests': this.selectedTabIndex = 2; break;
            case 'journal-completed-requests': this.selectedTabIndex = 3; break;
        }

        // Connect for download notifications and pick up a download already running or ready.
        void this.downloadJobService.initialize();
    }

    onTabChange(event: any) {
        switch (event.index) {
            case 0: this.router.navigate(['payment-completed-requests'], { relativeTo: this.route }); break;
            case 1: this.router.navigate(['expect-fund-completed'], { relativeTo: this.route }); break;
            case 2: this.router.navigate(['transfer-completed-requests'], { relativeTo: this.route }); break;
            case 3: this.router.navigate(['journal-completed-requests'], { relativeTo: this.route }); break;
        }
    }

    /** The grid the current tab shows; all four request types share one base. */
    private get grid(): ServerPagedHistoryGrid<HistoryRow> | undefined {
        const child = this.outlet?.component;
        return child instanceof ServerPagedHistoryGrid ? child : undefined;
    }

    resetFilters() {
        this.grid?.resetFilters();
    }

    exportData() {
        void this.grid?.exportDataToExcel();
    }

    get totalCount(): number {
        return this.grid?.totalCount ?? 0;
    }

    get isExporting(): boolean {
        return this.grid?.isExporting ?? false;
    }

    get selectedCount(): number {
        return this.grid?.selectedCount ?? 0;
    }

    /** True while a ZIP is being started or prepared; a user may have only one at a time. */
    get downloadBusy(): boolean {
        return this.downloadJobService.inProgress;
    }

    downloadAllAsPdf(): void {
        this.grid?.downloadAllAsPdf();
    }

    downloadSelectedAsPdf(): void {
        this.grid?.downloadSelectedAsPdf();
    }

}
